import {
  SET_SELECTED_SONG,
  TOGGLE_CURRENT_SONG_PLAY,
} from "../actions/currentSongActoins";
export default function (state = {}, action) {
  console.log("reducer", state);
  if (action.type === SET_SELECTED_SONG) {
    return action.payload.song;
  }
  if (action.type === TOGGLE_CURRENT_SONG_PLAY) {
    return { ...state, playing: !state.playing };
  }
  return state;
}
